import React, { useId } from 'react';
import { Form } from 'react-bootstrap';
import { UseFormRegister, UseFormWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

import { useAppDispatch } from '../../app/hook';
import PopoverWithAudio, { IPopoverWithAudioType } from '../../components/common/PopoverWithAudio';
import ProBadge from '../../components/ui/ProBadge';
import usePermission from '../../hooks/usePermission';
import { handleResetAppearance, handleUpdateAppearanceItem } from './appearanceSlice';
import { IAiAppearance } from './types';

type Props = {
  register: UseFormRegister<IAiAppearance>;
  watch: UseFormWatch<IAiAppearance>;
  className?: string;
};

function AppearanceNotificationComponent({ register, className }: Props) {
  const permissions = usePermission();
  const { i18n, t } = useTranslation();
  const dispatch = useAppDispatch();
  const id = useId();

  const voiceResponsePopData: IPopoverWithAudioType = {
    contentText: t('DashboardSettingCustomizeChat/pop-13'),
  };

  return (
    <div className={'tw-self-stretch tw-flex-col tw-justify-start tw-items-start tw-gap-3 tw-flex' + ` ${className}`} key={id}>
      <div className="tw-self-stretch tw-text-gray-700 tw-text-lg tw-font-semibold tw-font-['Lexend'] tw-leading-7">Notifications</div>
      <div className="tw-self-stretch tw-justify-start tw-items-start tw-gap-6 tw-flex tw-w-full tw-flex-col">
        <Form.Group className="tw-flex tw-items-center tw-gap-2 tw-mb-4">
          <Form.Check
            disabled={!permissions.settingsPage.widget.customization.notificationBadge}
            type="switch"
            id="notificationBadge"
            className="tw-flex tw-items-center tw-gap-2 tw-text-gray-700 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight"
            label={t('DashboardSettingCustomizeChat/l-14')}
            {...register('notificationBadge', {
              onChange: (e: any) => {
                dispatch(
                  handleUpdateAppearanceItem({
                    key: 'notificationBadge',
                    value: e.target.checked,
                  })
                );
              },
            })}
          />
          {!permissions.settingsPage.widget.customization.notificationBadge && (
            <ProBadge
              className="tw-ms-2"
              onClose={() => {
                dispatch(handleResetAppearance());
              }}
            />
          )}
          <PopoverWithAudio
            data={{
              contentText: voiceResponsePopData.contentText,
            }}
          />
        </Form.Group>
      </div>
    </div>
  );
}

export default WrappedErrorBoundary(AppearanceNotificationComponent);
